export const GET_APTITUDE_TEST_ATTEMPT = 'GET_APTITUDE_TEST_ATTEMPT';
export type GET_APTITUDE_TEST_ATTEMPT = typeof GET_APTITUDE_TEST_ATTEMPT;

export const GET_APTITUDE_TEST_SUCCESS = 'GET_APTITUDE_TEST_SUCCESS';
export type GET_APTITUDE_TEST_SUCCESS = typeof GET_APTITUDE_TEST_SUCCESS;

export const GET_APTITUDE_TEST_FAILURE = 'GET_APTITUDE_TEST_FAILURE';
export type GET_APTITUDE_TEST_FAILURE = typeof GET_APTITUDE_TEST_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/aptitude-test/get/Types.tsx